import React from 'react'
import './Tools.scss';
import {
    pdfSecuritySection,
    organizePdfSection,
    createPdfSection,
    editPdfSection,
    editImageSection,
    convertToPdfSection,
    convertFromPdfSection
} from './partials/ToolsData';
import ToolsSection from './partials/ToolsSection/ToolsSection';

export default function Tools() {
  return (
    <div className='tools-container'>
      <h2>Explore All the Powerful Tools Our App Offers</h2>
      <ToolsSection {...pdfSecuritySection} />
      <ToolsSection {...organizePdfSection} />
      <ToolsSection {...createPdfSection} />
      <ToolsSection {...editPdfSection} />
      <ToolsSection {...editImageSection} />
      <ToolsSection {...convertToPdfSection} />
      <ToolsSection {...convertFromPdfSection} />
    </div>
  )
}
